<template>
  <div></div>
</template>

<script>
import { WoozyMaterial } from '../../Reusable/WoozyMaterial'
import { O3DG2 } from '../../Reusable/O3DG2'
import { TextGeometry, Font, Mesh, Color, AdditiveBlending } from 'three'

export default {
  mixins: [O3DG2],
  methods: {
    async setup () {
      const makeFontGeo = ({ text, width }) => {
        return new Promise(async (resolve) => {
          // var loader = new THREE.FontLoader()
          // loader.load(, function (font) {
          // eslint-disable-next-line
          var font = await import('./Fonts/lovelo-bold.json')
          // var font = await import('../Fonts/work-sans-black.json')

          // var font = await import('../Fonts/roboto-regular.json')
          font = new Font(font)
          var geometry = new TextGeometry(text, {
            font: font,
            size: width,
            height: 0.62,
            curveSegments: 16,
            bevelEnabled: true,
            bevelThickness: 0.14,
            bevelSize: 0.11,
            bevelOffset: 0.001,
            bevelSegments: 3
          })
          geometry.computeBoundingBox()
          geometry.computeBoundingSphere()
          geometry.translate(geometry.boundingSphere.radius * -1, (geometry.boundingBox.max.y + geometry.boundingBox.min.y) * 0.25, 0)
          resolve(geometry)
          // })
        })
      }
      let text = 'Gallery'
      let geo = await makeFontGeo({ text, width: 8 })
      let mat = new WoozyMaterial()
      mat.envMap = this.ctx.cubeCam.out.envMap
      mat.uniforms.remixColor.value = new Color('#3a3a3a')
      mat.blending = AdditiveBlending
      mat.uniforms.useDudv.value = true
      this.onLoop(() => {
        mat.time += 0.0015
      })
      this.mesh = new Mesh(geo, mat)
      this.ctx.cubeCam.add(this.mesh)

      this.o3d.add(this.mesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>